import { useDispatch, useSelector } from 'react-redux';
import Router from 'next/router';

import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';

import { setTicketPopup } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { updateClientInfo } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { initialTicketPopupState, TConnectStep } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/reducer';
import { TState } from '~/src/store';

import ConnectionError from './ConnectionError';
import ConnectionPaid from './ConnectionPaid';
import ConnectionSuccess from './ConnectionSuccess';
import PaymentDeclined from './PaymentDeclined';
import QrFetchingError from './QrFetchingError';

const PopupContent: Record<TConnectStep, () => JSX.Element> = {
    success: ConnectionSuccess,
    paid: ConnectionPaid,
    error: ConnectionError,
    declined: PaymentDeclined,
    qrError: QrFetchingError,
    none: () => <></>,
};

const STEPS_WITH_REDIRECT: TConnectStep[] = ['success', 'paid'];

const TicketConnectionPopup = (): JSX.Element => {
    const dispatch = useDispatch();
    const { ticketPopup: { isOpen, step, title, text, type } } = useSelector((state: TState) => state.seasonTicketPayment);

    const Component = PopupContent[step] || PopupContent['none'];

    const onClose = () => {
        if (STEPS_WITH_REDIRECT.includes(step)) {
            // диспатч при клике на кнопку закрытия попапа ("крестик")
            dispatch(updateClientInfo());
            Router.push('/lk');
        } else {
            dispatch(setTicketPopup(initialTicketPopupState));
        }
    };
    return (
        <PopupResult
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            text={text}
            type={type}
        >
            <Component/>
        </PopupResult>
    );
};

export default TicketConnectionPopup;
